// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import logo from '@/assets/logo/hanggent.svg';
import { BRAND_NAME } from '@/lib/brand';
import { Link, Outlet } from 'react-router-dom';

/** Minimal chrome for pages that are reachable signed out (pricing). */
export default function PublicLayout() {
  return (
    <div className="relative flex h-full flex-col overflow-hidden">
      <div className="z-50 flex h-9 items-center justify-between border-b border-border/40 bg-background/95 px-2 py-1">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt={BRAND_NAME} className="h-5 w-5" />
          <span className="text-sm font-bold text-foreground">
            {BRAND_NAME}
          </span>
        </Link>
      </div>
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
